import React from 'react';

export function LimitDecimalColumnFormatter(cellContent) {
  return (
    <div dir='ltr' className="text-dark-75 font-weight-bolder d-block font-size-lg">
      {cellContent ? parseFloat(cellContent).toFixed(2): ''}
    </div>
  );
}
